import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  exportModalSetIsLoadingReducerType,
  exportModalSetCurrentViewReducerType,
  exportModalSetErrorsReducerType,
  exportModalSetEntriesReducerType,
  exportModalSetSelectedDatapointsReducerType,
  exportModalSetFormDataReducerType,
  exportModalSetDataReducerType,
  exportModalSetFormatsBackupReducerType,
  exportModalSetExportTypeReducerType,
  EXPORT_ERRORS,
  exportModalResetStateReducerType,
} from './ExportModalConstants';

export const initialState = Map({
  isLoading: false,
  currentView: null,
  entries: null,
  data: null,
  formData: {
    tab: {},
    format: {},
    range: {},
    export: null,
    options: {
      headline: '',
    },
  },
  selectedDatapoints: {
    ids: null,
    count: null,
    categories: null,
    items: null,
  },
  formatsBackup: false,
  exportType: null,
  errors: {
    [EXPORT_ERRORS.FORM_ERROR]: false,
    [EXPORT_ERRORS.RANGE_HIGH_ANONYMOUS_HINT]: false,
    [EXPORT_ERRORS.RANGE_HIGH_BIOACTIVITY_VISUALIZATION]: false,
    [EXPORT_ERRORS.RANGE_HIGH]: false,
    [EXPORT_ERRORS.RANGE_EMPTY]: false,
    [EXPORT_ERRORS.RANGE_FROM_TO]: false,
    [EXPORT_ERRORS.FORMAT]: true,
  },
});

const spec = {
  [exportModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [exportModalSetCurrentViewReducerType]: (state, action) => {
    const { currentView } = action.payload;
    return state.set('currentView', currentView);
  },
  [exportModalSetEntriesReducerType]: (state, action) => {
    const { entries } = action.payload;
    return state.set('entries', entries);
  },
  [exportModalSetDataReducerType]: (state, action) => {
    const { data } = action.payload;
    return state.set('data', data);
  },
  [exportModalSetFormDataReducerType]: (state, action) => {
    const { formData } = action.payload;
    return state.set('formData', formData);
  },
  [exportModalSetSelectedDatapointsReducerType]: (state, action) => {
    const { selectedDatapoints } = action.payload;
    return state.set('selectedDatapoints', selectedDatapoints);
  },
  [exportModalSetFormatsBackupReducerType]: (state, action) => {
    const { formatsBackup } = action.payload;
    return state.set('formatsBackup', formatsBackup);
  },
  [exportModalSetExportTypeReducerType]: (state, action) => {
    const { exportType } = action.payload;
    return state.set('exportType', exportType);
  },
  [exportModalSetErrorsReducerType]: (state, action) => {
    const errors = state.get('errors');
    const { type, value } = action.payload;
    return state.set('errors', { ...errors, [type]: value });
  },
  [exportModalResetStateReducerType]: () => {
    return initialState;
  },
};

export default createReducerBySpec(spec, initialState);
